import { useTranslation } from 'react-i18next';

import { useJobTitles } from '../../queries';
import { Select } from '@/shared/ui/atoms/Select';

type Props = { id: string; value: string; onChange: (value: string) => void };

/**
 * The organisation's job titles as a list (no free text). A member's current title that is no longer in the
 * catalogue is still shown so editing other fields does not force a change.
 */
export function JobTitleSelect({ id, value, onChange }: Props) {
  const { t } = useTranslation();
  const titles = useJobTitles();
  const names = (titles.data ?? []).map((jt) => jt.name);
  const legacy = value && !names.some((n) => n.toLowerCase() === value.toLowerCase()) ? value : null;
  return (
    <Select icon="user-tie" id={id} value={value} onChange={(e) => onChange(e.target.value)} required>
      <option value="" disabled>
        {titles.isPending ? t('common.loading') : names.length === 0 ? t('people.noJobTitles') : t('people.jobTitleChoose')}
      </option>
      {legacy ? <option value={legacy}>{legacy}</option> : null}
      {names.map((n) => (
        <option key={n} value={n}>
          {n}
        </option>
      ))}
    </Select>
  );
}
